export default function EssentialNotice() {
  return (
    <section className="w-full py-14" style={{ backgroundColor: '#f4faf8' }}>
      <div className="max-w-5xl mx-auto px-6 space-y-8">

        {/* 핵심 요약 배너 */}
        <div
          className="rounded-2xl p-6 md:p-8"
          style={{ background: 'linear-gradient(135deg, #0d2b24 0%, #1a4a3a 100%)' }}
        >
          <div className="flex items-center gap-3 mb-6">
            <div
              className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0"
              style={{ backgroundColor: 'rgba(111,207,184,0.2)' }}
            >
              <i className="ri-alarm-warning-line text-xl" style={{ color: '#6fcfb8' }}></i>
            </div>
            <div>
              <p className="text-xs font-bold tracking-widest uppercase" style={{ color: '#6fcfb8' }}>MUST KNOW</p>
              <h3 className="text-base font-bold text-white">꼭! 지켜야 할 핵심 5가지</h3>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              {
                num: '①',
                title: '입원 전·당일 가족간병 등록',
                desc: '등록 이전일 소급 적용 불가 — 반드시 입원 전 또는 당일 등록',
              },
              {
                num: '②',
                title: '보험가입자 → 간병인 직접 이체',
                desc: '1일 최소 10만원 이상 · 제3자 이체 및 현금 지급 불가',
              },
              {
                num: '③',
                title: '코리아케어러스 공식 양식으로 간병일지 작성',
                desc: '매일 빠짐없이 작성 · 간병인 서명 필수',
              },
              {
                num: '④',
                title: '퇴원 시 입퇴원확인서 발급',
                desc: '입원일·퇴원일·병명·담당의 서명 포함 확인',
              },
              {
                num: '⑤',
                title: '3가지 서류 모두 제출',
                desc: '입퇴원확인서 + 간병비 이체내역 + 간병일지 → 카카오 채팅방 또는 팩스',
              },
            ].map((item, i) => (
              <div
                key={i}
                className={`rounded-xl p-4 ${i === 4 ? 'md:col-span-2' : ''}`}
                style={{ backgroundColor: 'rgba(255,255,255,0.07)' }}
              >
                <p className="text-xs font-bold mb-1" style={{ color: '#6fcfb8' }}>
                  {item.num} {item.title}
                </p>
                <p className="text-xs leading-relaxed" style={{ color: 'rgba(255,255,255,0.7)' }}>
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* 간병일지 다운로드 */}
        <div
          className="rounded-2xl p-6 border"
          style={{ backgroundColor: '#fff', borderColor: 'rgba(46,125,107,0.2)' }}
        >
          <div className="flex items-center gap-2 mb-2">
            <i className="ri-download-2-line text-base" style={{ color: '#2E7D6B' }}></i>
            <h4 className="text-sm font-bold text-gray-900">간병일지 양식 다운로드</h4>
          </div>
          <p className="text-xs text-gray-500 leading-relaxed mb-5">
            보험사별 간병일지 양식은 상이할 수 있으니,{' '}
            <strong className="text-gray-700">생명보험 가입자의 경우 당사로 연락</strong> 부탁드립니다.
          </p>
          <div className="flex flex-wrap gap-3">
            <a
              href="https://storage.readdy-site.link/project_files/85651164-9881-44bb-8cd7-002bfdcb405b/5c697202-8ad9-4e34-ac08-218afddde98f_-_.jpg?v=070242f12d6341e7692f61bf2fab374f"
              download="간병일지_코리아케어러스.jpg"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold text-white whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
              style={{ backgroundColor: '#2E7D6B' }}
            >
              <i className="ri-image-line"></i>간병일지 양식 (JPG) 다운로드
            </a>
            <a
              href="https://storage.readdy-site.link/project_files/85651164-9881-44bb-8cd7-002bfdcb405b/4c16399f-393b-4b34-8cba-ab9c90f2097a_-_.pdf?v=39a1b7db47ac57a7935e46154017abc8"
              download="간병일지_코리아케어러스.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
              style={{ backgroundColor: '#f0f9f6', color: '#2E7D6B', border: '1px solid #2E7D6B' }}
            >
              <i className="ri-file-pdf-line"></i>간병일지 양식 (PDF) 다운로드
            </a>
          </div>
        </div>

        {/* 고객센터 + CTA */}
        <div
          className="rounded-2xl p-6 flex flex-col sm:flex-row items-start sm:items-center gap-5"
          style={{ backgroundColor: '#f0f9f6', border: '1px solid rgba(46,125,107,0.2)' }}
        >
          <div
            className="w-12 h-12 flex items-center justify-center rounded-2xl flex-shrink-0"
            style={{ backgroundColor: 'rgba(46,125,107,0.12)' }}
          >
            <i className="ri-customer-service-2-line text-2xl" style={{ color: '#2E7D6B' }}></i>
          </div>
          <div className="flex-1">
            <p className="text-xs font-semibold text-gray-500 mb-0.5">코리아케어러스 고객센터</p>
            <a
              href="tel:15668654"
              className="text-2xl font-black block cursor-pointer hover:opacity-80 transition-opacity"
              style={{ color: '#2E7D6B' }}
            >
              1566-8654
            </a>
            <p className="text-xs text-gray-400 mt-0.5">오전 9시 ~ 오후 11시 · 연중무휴</p>
          </div>
          <div className="flex flex-col gap-2 flex-shrink-0">
            <a
              href="/register"
              className="flex-shrink-0 px-5 py-2.5 rounded-xl text-sm font-bold text-white whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
              style={{ backgroundColor: '#2E7D6B' }}
            >
              <i className="ri-user-add-line mr-1.5"></i>가족간병 등록하기
            </a>
            <a
              href="/process"
              className="flex-shrink-0 px-5 py-2.5 rounded-xl text-sm font-bold whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity text-center"
              style={{ backgroundColor: '#f0f9f6', color: '#2E7D6B', border: '1px solid #2E7D6B' }}
            >
              <i className="ri-file-list-3-line mr-1.5"></i>청구절차 보기
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}
